import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
  visuallyHidden,
} from '../styles';
import { Container } from './ui';
import ProductCategoryCard from './ProductCategoryCard';

const StyledFeaturedProductCategories = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled.h2`
  ${visuallyHidden()};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 15px;

  ${minBreakpointQuery.small`
    gap: 20px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: 200px;
  `}

  ${minBreakpointQuery.large`
    grid-auto-rows: 220px;
    gap: 25px;
  `}
`;

const StyledItem = styled(ProductCategoryCard)`
  ${maxBreakpointQuery.smedium`
    height: 50vw;
    max-height: 200px;
  `}

  ${minBreakpointQuery.smedium`
    grid-column: span 6;
  `}

  &:nth-child(4n - 1) {
    ${minBreakpointQuery.smedium`
      grid-column: span 7;
    `}
  }

  &:nth-child(4n) {
    ${minBreakpointQuery.smedium`
      grid-column: span 5;
    `}
  }
`;

const FeaturedProductCategories = ({ heading, items }) => (
  <StyledFeaturedProductCategories>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map(item => (
          <StyledItem
            key={item.id}
            image={item.featuredImage}
            heading={item.title}
            page={item}
          />
        ))}
      </StyledItems>
    </Container>
  </StyledFeaturedProductCategories>
);

export default FeaturedProductCategories;
